<template>
  <div v-if="active || failed.length > 0" class="group-loading" :class="{ 'is-warn': !active }">
    <template v-if="active">
      <div class="d-flex align-items-center">
        <span class="spinner-border spinner-border-sm me-2" role="status"></span>
        <b>{{ title }}</b>
        <span v-if="seconds >= 3" class="ms-2 text-sm">{{ $t("content.shopgrp_waited", { s: seconds }) }}</span>
      </div>
      <div v-if="total > 1" class="mt-2">
        <div class="text-sm mb-1">{{ $t("content.shopgrp_progress", { done, total }) }}</div>
        <div class="progress group-loading-bar">
          <div class="progress-bar bg-success" role="progressbar" :style="'width: ' + percent + '%;'"></div>
        </div>
      </div>
    </template>
    <div v-else class="d-flex align-items-center">
      <i class="material-icons material-symbols-outlined me-2">warning</i>
      <span>{{ $t("content.shopgrp_failed", { shops: failed.join(", ") }) }}</span>
      <material-button color="warning" variant="outline" size="sm" class="ms-auto mb-0" @click="emit('retry')">
        {{ $t("buttons.sear") }}
      </material-button>
    </div>
  </div>
</template>

<script setup>
// แถบสถานะตอนดึงข้อมูลหลายสาขา — query หลายสาขาฝั่ง server ยังช้า (ยังไม่ได้
// ปรับ) จึงต้องบอกให้ชัดว่ายังโหลดอยู่ ไม่ได้ค้าง: จำนวนสาขา, เวลาที่รอไปแล้ว
// (หลัง 3 วินาที) และความคืบหน้าของข้อมูลที่ต้องยิงทีละสาขา
import { ref, computed, watch, onBeforeUnmount, defineProps, defineEmits } from "vue";
import MaterialButton from "@/components/MaterialButton.vue";

const props = defineProps({
  active: { type: Boolean, default: false },
  title: { type: String, default: "" },
  done: { type: Number, default: 0 },
  total: { type: Number, default: 0 },
  failed: { type: Array, default: () => [] },
});
const emit = defineEmits(["retry"]);

const seconds = ref(0);
let timer = null;

const percent = computed(() => (props.total > 0 ? Math.round((props.done / props.total) * 100) : 0));

function stop() {
  if (timer) {
    clearInterval(timer);
    timer = null;
  }
}

watch(
  () => props.active,
  (active) => {
    stop();
    seconds.value = 0;
    if (active) {
      const startedAt = Date.now();
      timer = setInterval(() => {
        seconds.value = Math.floor((Date.now() - startedAt) / 1000);
      }, 1000);
    }
  },
  { immediate: true }
);

onBeforeUnmount(stop);
</script>

<style scoped>
.group-loading {
  background: #e8fef2;
  border: 1px solid #05af50;
  border-radius: 10px;
  color: #05602d;
  padding: 10px 14px;
  margin: 10px 0;
}

.group-loading.is-warn {
  background: #fff7ed;
  border-color: #fb8c00;
  color: #9a3412;
}

.group-loading-bar {
  height: 6px;
}
</style>
